import { FunctionComponent } from 'react'

import { LoadingOutlined } from '@ant-design/icons'
import { useTheme } from 'styled-components'

import { LoadingSpinnerProps } from './props'

import { Spinner } from './styles'

export const LoadingSpinner: FunctionComponent<LoadingSpinnerProps> = ({
  color,
  size = 'default',
  className,
}) => {
  const theme = useTheme()
  const spinnerColor = color || theme.unchangingColor.white

  return (
    <Spinner
      data-testid='loading-spinner'
      size={size}
      rootClassName={className}
      indicator={<LoadingOutlined style={{ color: spinnerColor }} />}
    />
  )
}
